<template>
    <div>
        <!--<core-filter />-->
        <core-toolbar/>
        <core-drawer v-if='base_info_finish' :items="items"/>
        <core-view/>


    </div>
</template>

<script>

    import LoadingBar from '../components/LoadingBar'
    import {mapGetters} from 'vuex'

    export default {
        name: 'Main',
        components: {
            LoadingBar,
        },
        data: () => ({
            progressBarClass: 'progressBar hide',
            base_info_finish: false,
            items: []
        }),

        created() {

            console.log(`Log ${this.$options.name} created `)
            this.createSideMenu()

        },


        methods: {

            ...mapGetters('user', ['getLoginType']),

            createSideMenu() {

                this.items = []
                if (Number(this.getLoginType()) >= 3) {
                    this.items = [
                        {
                            to: '/dashboard',
                            icon: 'mdi-view-dashboard',
                            text: 'dashboard'
                        },
                        {
                            to: '/users',
                            icon: 'mdi-account',
                            text: 'users'
                        },
                        {
                            to: '/contents',
                            icon: 'mdi-clipboard-outline',
                            text: 'contents'
                        },
                        {
                            to: '/notices',
                            icon: 'mdi-bell-outline',
                            text: 'notice'
                        },
                        {
                            to: '/terms',
                            icon: 'mdi-code-tags',
                            text: 'terms'
                        },
                    ]
                } else {
                    this.items = [
                        {
                            to: '/contents',
                            icon: 'mdi-clipboard-outline',
                            text: 'contents'
                        },
                    ]
                }

                this.base_info_finish = true
            },
        }


    }
</script>


<style lang="scss">

    /*@import "../assets/styles/common";*/
    @import '../assets/styles/index.scss';


</style>
